document.addEventListener("DOMContentLoaded", () => {
  // Product Gallery
  const featuredImg = document.getElementById("ProductPhotoImg")
  const thumbnails = document.querySelectorAll(".thumbnail-item")

  if (featuredImg && thumbnails.length > 0) {
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", function () {
        // Get the image inside the thumbnail
        const thumbnailImg = this.querySelector("img")

        // Update featured image
        const newSrc = thumbnailImg.src.replace("_compact", "_large")
        const newAlt = thumbnailImg.alt
        featuredImg.src = newSrc
        featuredImg.alt = newAlt

        // Update active state
        document.querySelector(".thumbnail-item.active").classList.remove("active")
        this.classList.add("active")
      })
    })
  }

  // Product Tabs
  const tabButtons = document.querySelectorAll(".tab-button")
  const tabPanels = document.querySelectorAll(".tab-panel")

  if (tabButtons.length > 0 && tabPanels.length > 0) {
    tabButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const tabId = this.getAttribute("data-tab")

        // Update active tab button
        tabButtons.forEach((btn) => btn.classList.remove("active"))
        this.classList.add("active")

        // Update active tab panel
        tabPanels.forEach((panel) => panel.classList.remove("active"))
        document.getElementById(tabId).classList.add("active")
      })
    })
  }
})
